module.exports = __webpack_public_path__ + "static/media/hot.fc95437a.svg";